import { AVAILABLE_SERVICE, CONSULTATION_TYPE, OTHER_SERVICE } from '@abiglobalhealth/go-types'

import { NavigatorIcon } from '@/components/icons/consultations/NavigatorIcon'
import { PrescriptionIcon } from '@/components/icons/consultations/PrescriptionIcon'
import { ProfessionalAssessmentIcon } from '@/components/icons/consultations/ProfessionalAssessmentIcon'
import { TextConsultationIcon } from '@/components/icons/consultations/TextConsultationIcon'
import { VideoConsultationIcon } from '@/components/icons/consultations/VideoConsultationIcon'
import { VoiceConsultationIcon } from '@/components/icons/consultations/VoiceConsultationIcon'
import { cn } from '@/utils/tailwind'

interface ConsultationIconProps {
  consultationType: AVAILABLE_SERVICE
  containerClassName?: string
  customClassName?: string
  outlined?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const CONSULTATION_ICONS: Record<AVAILABLE_SERVICE, any> = {
  [CONSULTATION_TYPE.MEDICAL]: TextConsultationIcon,
  [CONSULTATION_TYPE.VIDEO]: VideoConsultationIcon,
  [CONSULTATION_TYPE.VOICE]: VoiceConsultationIcon,
  [CONSULTATION_TYPE.PRESCRIPTION]: PrescriptionIcon,
  [CONSULTATION_TYPE.MENTAL]: ProfessionalAssessmentIcon,
  [OTHER_SERVICE.HEALTH_NAVIGATOR]: NavigatorIcon
}

export const ConsultationIcon = ({
  consultationType = CONSULTATION_TYPE.MEDICAL,
  containerClassName,
  customClassName,
  outlined,
  ...props
}: ConsultationIconProps) => {
  const Component = CONSULTATION_ICONS[consultationType]
  return (
    <span className={cn('grid h-10 place-items-center', containerClassName)}>
      <Component customClassName={cn('transition-all', customClassName, outlined ? 'h-6 w-6 opacity-80' : 'h-10 w-10')} {...props} />
    </span>
  )
}
